import React from 'react';
import { ReviewBladeInfoProps } from '../type';
import phoneNoContent from '../../assets/phone_no_content.svg';

const NoReviews: React.FC<ReviewBladeInfoProps> = ({ isLoading }) => {
    if (isLoading) {
        return null;
    }

    return (
        <>
            <div className="m-auto py-8">
                <div className="flex flex-col items-center gap-3">
                    <img className="w-32 h-32" src={phoneNoContent} alt="no reviews available" />
                    <p className="p-0 m-0 text-[#9B9B9B]">Aucun contenu pour le moment !</p>
                    <p className="p-0 m-0 text-[#9B9B9B]">
                        Les avis laissés par vos clients s’afficheront ici une fois postés.
                    </p>
                </div>
            </div>
        </>
    );
};

export default NoReviews;
